import {RemotePostB2BBeneficiaryAuthorization} from 'data/usecases/private/profile/remote-post-b2b-beneficiary-authorization';
import {PostB2BBeneficiaryAuthorization} from 'domain/usecases/private/profile/post-b2b-beneficiary-authorization';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {B2BEndPoints} from 'main/factories/usecases/endpoints';

export const makePostB2BBeneficiaryAuthorization = (): PostB2BBeneficiaryAuthorization =>
	new RemotePostB2BBeneficiaryAuthorization(
		makeBFFApiUrl(B2BEndPoints.permissionCompany),
		makeAuthorizeHttpClientDecorator(),
	);
